<template>
  <div class="product-info">

   <jimi-card v-if="serviceData" :title="$t('HT.advancedService.serviceData')">
    <jimi-card-item :label="$t('HT.advancedService.serviceStatus')">
      <span class="form-val" :style="{color:['', '#3DC456', '#E6A23C','#F45C5C'][serviceData.strategyStatus]}">{{ serviceData.strategyStatus| strategyStatusFilter }}</span>
    </jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.monthRemaining')">{{ serviceData.remainQuato }} {{ $t('HT.advancedService.times') }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.remainingDuration')">{{ serviceData.remainDuration }} {{ $t('HT.advancedService.day') }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.monthUsage')">{{ serviceData.usedQuato }} {{ $t('HT.advancedService.times') }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.usedDuration')">{{ serviceData.usedDuration }} {{ $t('HT.advancedService.day') }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.orderQuato')">{{ serviceData.qutao }} {{ $t('HT.advancedService.times') }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.orderDuration')">{{ serviceData.orderDuration }} {{ $t('HT.advancedService.day') }}</jimi-card-item>
   </jimi-card>

   <jimi-card v-if="detailData" :title="$t('HT.advancedService.baseData')">
    <jimi-card-item :label="$t('HT.advancedService.orderTime')">{{ detailData.orderCreateTime }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.orderId')">{{ detailData.orderId }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.strategyId')">{{ detailData.strategyId }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.user.id')">{{ detailData.userId }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.userAccount')">{{ detailData.userAccount }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.userName')">{{ detailData.userName }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.packageName')">{{ detailData.packageName }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.serviceName')">{{ detailData.serviceName }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.orderQuato')">{{ detailData.quato }} <span class="text-color" @click="showEdit(detailData.quato)">{{ $t('HT.edit2')+$t('HT.advancedService.limit') }}</span></jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.serviceType')">{{ detailData.serviceType }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.addLicense.expireDate')">{{ $t('HT.advancedService.effective') }} {{ detailData.orderStartTime }} {{ $t('HT.advancedService.expired') }} {{ detailData.orderEndTime }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.advancedService.sourcePlatform')">{{ detailData.source }}</jimi-card-item>
    <jimi-card-item :label="$t('HT.upgrade.mctype')">{{ detailData.mcTypes.join('、') }}</jimi-card-item>
    <!-- <jimi-card-item label="设备">查看设备</jimi-card-item> -->
   </jimi-card>


  
    <template v-if="chartOption.length">
      <line-chart  v-for="(option, index) of chartOption" :option="option" :el="'echart-wrap'+index" :index="index" @change="changeChart" />
    </template>
  </div>
</template>

<script>
import lineChart from './components/lineChart';
import addApply from './components/addApply';
export default {
  components: {
    lineChart,
    addApply
  },
  data() {
    return {
      isShow: true,
      detailData: null,
      serviceData: null,
      // 表的数据
      tableData: {
        totalSize: 0,
        list: []
      },
     
      chartOption: [],
    };
  },
  mounted() {
    this.getDetail()
    this.getChartData({})
  },
  beforeRouteLeave(to, from, next){
    sessionStorage.removeItem('deviceDetail');
    next();
  },
  methods: {
    async getDetail() {
      let {code,data}=await this.$api.advancedService.getStrategyDetail({strategyId:this.$route.query.id})
      if (code == 10000) {
        this.detailData=data.basicInfo;
        this.serviceData=data.service;
        }
      
    },
    async getChartData({dateType='1',startTime='',endTime=''}) {
      let params = {
        strategyId:this.$route.query.id,
        dateType,
        startTime,
        endTime,
      };
      let { data } = await this.$api.advancedService.getStrategyReport(params);
      this.setChartData(data)
      return data;
    },
    async updateQuato(quato) {
      let params = {
        strategyId:this.$route.query.id,
        quato,
      };
     const {code}=await this.$api.advancedService.updateQuato(params);
     if (code === 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
            this.getDetail()
        }
    
    },

    setChartData(data){
      const xAxisData=data.map(item=>item.date);
      const seriesData=data.map(item=>item.count);
      let obj={
        xAxisData,
        seriesData
      };
      this.chartOption=[obj]

    },

    async changeChart({index,...rest}) {
      let data= await this.getChartData(rest);
      this.setChartData(data,index);
    },
    showEdit(quato) {
        const title = this.$t('HT.edit2')+this.$t('HT.advancedService.limit');
        this.$uxModal.show({
          title,
          content: (h) => {
            return h(addApply, {
              props: { data:{quato} },
              on: {}
            });
          },
          confirm: (data) => {
            this.updateQuato(data.quato);
          }
        });
      },

  }
};
</script>

<style lang="scss" scoped>
.product-info {
  padding-bottom: 20px;

  .info-content {
    .api_words {
      margin: 0 0 10px 0;
    }
  }
}
.text-color{
  color: #0087ff;
  cursor: pointer;
}
</style>
